import { render, staticRenderFns } from "./Legalnotice.vue?vue&type=template&id=de2dd368&scoped=true&"
import script from "./Legalnotice.vue?vue&type=script&lang=js&"
export * from "./Legalnotice.vue?vue&type=script&lang=js&"
import style0 from "./Legalnotice.vue?vue&type=style&index=0&id=de2dd368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2dd368",
  null
  
)

export default component.exports